import { render, staticRenderFns } from "./Zxgxb.vue?vue&type=template&id=f938c61c&scoped=true"
import script from "./Zxgxb.vue?vue&type=script&lang=js"
export * from "./Zxgxb.vue?vue&type=script&lang=js"
import style0 from "./Zxgxb.vue?vue&type=style&index=0&id=f938c61c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f938c61c",
  null
  
)

export default component.exports